// Resolves external CMS links (Datenschutz, AGB) for either the new Shopify
// storefront (default) or the legacy Neos site. Mirrors the helper in
// webservice-customer so the same ?cms= switch flips both apps.
//
// Selection:
//   1. window.MEET_CMS (set inline if you ever wire up a bootstrap script)
//   2. ?cms=<key> on the iframe URL (the default - parent Neos page
//      forwards its own ?cms= via the iframe data-src snippet)
//   3. default 'shopify'

const CMS_PAGES = {
  neos: {
    agb: 'https://www.maluwilz.de/de/agb.html',
    datenschutz: 'https://www.maluwilz.de/de/datenschutz.html'
  },
  shopify: {
    agb: 'https://www.maluwilz.de/de-de/pages/agb-b2b',
    datenschutz: 'https://www.maluwilz.de/de-de/policies/privacy-policy'
  }
}

export function getCms () {
  if (typeof window === 'undefined') return 'shopify'
  if (window.MEET_CMS) return window.MEET_CMS
  try {
    const fromQuery = new URLSearchParams(window.location.search).get('cms')
    if (fromQuery) return fromQuery
  } catch (e) { /* no-op */ }
  return 'shopify'
}

export function cmsPage (key) {
  const cms = getCms()
  return (CMS_PAGES[cms] || CMS_PAGES.shopify)[key]
}
